import React from 'react';
import Formsy from 'formsy-react';
import moment from 'moment';
import FormsySimpleInput from '../../form/FormsySimpleInput';
import withSplashMessage from '../../splashMessage/withSplashMessage';
import { menuSelectionMaxQuantity } from '../../../const';
import MenuSelectionCard from '../../shared/MenuSelectionCard';
import MenuSelectionModal from '../../shared/MenuSelectionModal';
import { onBoardingAPI } from '../../../InterfaceAPI/onboardingAPI';
import { isEmptyObj, stringfyServerErrors } from '../../../helpers/util';
import Loader from '../../shared/Loader';
import {
  generateMenuSelections,
  populateMenuSelections
} from '../../../helpers/menuSelection';

class ClientMenu extends React.Component {
  state = {
    menu: {},
    menu_selections: [],
    isOpen: false,
    activeSelectionIndex: -1
  };

  render() {
    const { courses = [] } = this.state.menu;
    const total = this.calcTotalSelections();

    if (this.state.isLoading) return <Loader />;

    if (courses.length > 0)
      return (
        <div className="on-boarding__step on-boarding_step--client on-boarding__step--relative">
          <div className="on-boarding__wrap on-boarding__wrap--menu-selection">
            <h1 className="on-boarding__h1">
              Which dishes would you like for your first week?
            </h1>
            <p className="on-boarding__p">
              Select up to six dishes 48 hours in advance of your service.
            </p>
            <Formsy
              onValidSubmit={this.handleSubmit}
              onInvalidSubmit={this.handleInvalidSubmit}
              onValid={this.handleValid}
              onInvalid={this.handleInvalid}
            >
              <FormsySimpleInput
                type="hidden"
                name="total"
                value={total}
                placeholder="Total"
                validations="isGreaterThan:0"
              />
              <FormsySimpleInput
                type="hidden"
                name="all_forms_valid"
                value={this.props.actions.isValid('submit')}
                validations="isTrue"
              />

              {courses && courses.map(course => this.renderCourse(course))}

              <input
                ref={this.props.actions.assignTrigger}
                type="submit"
                hidden
              />
            </Formsy>
          </div>
          <MenuSelectionModal
            isOpen={this.state.isOpen}
            index={this.state.activeSelectionIndex}
            menu_selection={
              this.state.activeSelectionIndex >= 0
                ? this.state.menu_selections[this.state.activeSelectionIndex]
                : {}
            }
            updateMenuSelection={this.updateMenuSelection}
            closeModal={this.closeModal}
          />
        </div>
      );
    else
      return (
        <div className="on-boarding__step on-boarding_step--client">
          <div className="on-boarding__wrap on-boarding__wrap--menu-selection">
            <h1 className="on-boarding__h1">
              Select your menu at a later date.
            </h1>
            <p className="on-boarding__p">
              Since your first service date is more than a month away, you’ll
              choose your menu at a later date. Don’t worry, we’ll send you an
              email notifying you when your menu is available.
            </p>

            <Formsy
              onValidSubmit={this.handleSubmit}
              onInvalidSubmit={this.handleInvalidSubmit}
              onValid={this.handleValid}
              onInvalid={this.handleInvalid}
            >
              <input
                ref={this.props.actions.assignTrigger}
                type="submit"
                hidden
              />
            </Formsy>
          </div>
        </div>
      );
  }

  renderCourse(course) {
    const { dishes = [] } = course;
    return (
      <div key={course.id} className="menu-selection-course">
        <div className="menu-selection-course__name">{course.name}</div>
        <div className="menu-selection-cards">
          {dishes &&
            dishes.map(dish => {
              const index = this.state.menu_selections.findIndex(
                selection => selection.dish_id === dish.id
              );
              return (
                <MenuSelectionCard
                  key={dish.id}
                  dish={dish}
                  index={index}
                  menu_selection={
                    index >= 0
                      ? this.state.menu_selections[index]
                      : this.defaultMenuSelection(dish)
                  }
                  updateMenuSelection={this.updateMenuSelection}
                  openModal={this.openModal}
                  closeModal={this.closeModal}
                />
              );
            })}
        </div>
      </div>
    );
  }

  openModal = activeSelectionIndex =>
    this.setState({ isOpen: true, activeSelectionIndex });

  closeModal = () => this.setState({ isOpen: false, activeSelectionIndex: -1 });

  calcTotalSelections = (menu_selections = this.state.menu_selections) => {
    return menu_selections.reduce(
      (accum, selection) => selection.quantity + accum,
      0
    );
  };

  updateMenuSelection = (index, menu_selection) => {
    // if it's not in there, throw it at the end
    const menu_selections =
      index === -1
        ? [...this.state.menu_selections, menu_selection]
        : // if it is, updated it.
          [
            ...this.state.menu_selections.slice(0, index),
            { ...menu_selection },
            ...this.state.menu_selections.slice(
              index + 1,
              this.state.menu_selections.length
            )
          ];

    const total = this.calcTotalSelections(menu_selections);
    if (total > menuSelectionMaxQuantity)
      this.props.addMessage({
        className: 'error',
        message: 'Error - You can only select up to 6 dishes'
      });
    else {
      this.setState({ menu_selections });
      this.props.updateNavExtras({ menu_selections });
    }
  };

  handleChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleInvalidSubmit = () => console.log('failed submit');

  handleValid = () => this.props.actions.setValidState('main', true);
  handleInvalid = () => this.props.actions.setValidState('main', false);

  // this will be triggered from the ChefOnboarding component
  handleSubmit = (formData, data, errors) => {
    const menu_selections = this.state.menu_selections.filter(
      selection => selection.quantity > 0
    );
    const service_week = this.getServiceWeek(
      this.props.client.service_start_date
    );
    this.props.updateClient({ menu_selections, service_week });
    this.props.actions.markComplete(this.props.step);
  };

  getServiceWeek = date =>
    moment(date)
      .day(0)
      .format('YYYY-MM-DD');

  didServiceWeekChange = () => {
    if (!this.props.client.service_week) return true;

    const service_week = this.getServiceWeek(
      this.props.client.service_start_date
    );
    return this.props.client.service_week !== service_week;
  };

  reset() {
    // verify service_week has changed.
    this.props.updateClient({ menu_selections: [], service_week: null });
    this.setState({ menu: {}, menu_selections: [] });
  }

  lookupMenu() {
    this.setState({ isLoading: true });
    const service_week = this.getServiceWeek(
      this.props.client.service_start_date
    );

    onBoardingAPI
      .lookupMenus()
      .then(({ menus }) => {
        // load the menu
        const menu =
          menus.find(menu => menu.service_week === service_week) || {};
        const { menu_selections: clientSelections = [] } = this.props.client;
        let menu_selections = [];

        // if we have menu_selections, populate menu_selections
        if (clientSelections.length > 0)
          menu_selections = populateMenuSelections(menu, clientSelections);
        // else, generate new menu_selections
        else if (menu && menu.courses)
          menu_selections = generateMenuSelections(menu);

        this.setState({
          menu,
          menu_selections,
          service_week,
          isLoading: false
        });
      })
      .catch(err => {
        this.props.addMessage({
          className: 'error',
          message: stringfyServerErrors(err)
        });
      });
  }

  initState(prevProps = {}) {
    const state = {};

    // init client state from props
    if (this.props.client !== prevProps.client) {
      this.lookupMenu();
    }

    if (!isEmptyObj(state)) this.setState(state);
  }

  componentWillMount() {
    // handle resets here
    const reset = this.props.resets.includes(this.props.step);
    if (reset && this.didServiceWeekChange()) this.reset();

    this.initState();
  }

  componentDidUpdate(prevProps, nextState) {
    this.initState(prevProps);
  }

  componentWillUnmount() {
    this.props.updateNavExtras({ menu_selections: [] });
  }
}

export default withSplashMessage(ClientMenu);



// WEBPACK FOOTER //
// ./src/components/onboarding/client/ClientMenu.js